import { Component, OnInit } from '@angular/core';
import { CompanyDetailsService } from '../services/company-details.service';
import { LoaderService } from '../services/loader.service';
import { PaymentService } from '../services/payment.service';
import { UserService } from '../services/user.service';
// import { jsPDF } from "jspdf";
// import * as pdfMake from "pdfmake/build/pdfmake";
// import * as pdfFonts from "pdfmake/build/vfs_fonts";
import { LogService } from '../services/log.service';
import { GeneralService } from '../services/general.service';
// (pdfMake as any).vfs = pdfFonts.pdfMake.vfs;

// const htmlToPdfmake = require("html-to-pdfmake");

@Component({
  selector: 'app-payment-history',
  templateUrl: './payment-history.component.html',
  styleUrls: ['./payment-history.component.css']
})
export class PaymentHistoryComponent implements OnInit {
  public paymentHistory = [];
  public paymentGateway = '';
  public fullName = '';
  public passport = '';
  public matric_no = '';
  public company_initial: any;
  public company_logo: any;
  public company_name: any;
  public company_address: any;

  public studentData: any;

  public totalAmount = 0;
  public totalAmountPaid = 0;
  public totalBalance = 0;
  constructor (public _loaderService: LoaderService,
    public _paymentService: PaymentService,
    public _generalService: GeneralService,
    public _companyDetailsService: CompanyDetailsService,
    public _userService: UserService, public log: LogService) { }

  ngOnInit () {
    this.getPaymentGateway();
    this.getUserData();
    this.getClearanceOffices();
    this.log
      .addLog({
        action: "Access",
        component: "Payment History",
        details: `Accessed Payment History`,
      }).subscribe(data => { });
  }

  getTransactionHistory () {
    this._loaderService.emitChange(true);
    this._paymentService.studentPaymentHistory().subscribe(data => {
      this._loaderService.emitChange(false);
      this.paymentHistory = data;
      // this.invoicesArr = response;
      this.paymentHistory.map((i) => {
        i['label'] = `${i.category} - ${i.name} - ${i.tag} - ${i.term} - ${i.session_year}`
        this.totalAmount += i.total_amount;
        this.totalAmountPaid += i.total_paid;
        this.totalBalance += i.amount_remaining;
      });
    })
  }

  getPaymentGateway () {
    this._companyDetailsService.getDetails().subscribe(data => {
      this.paymentGateway = data.payment_gateway;
      this.company_initial = data.adm_initial;
      this.company_logo = data.logo;
      this.company_name = data.name;
      this.company_address = data.address;
      this.getTransactionHistory();
    })
  }

  getUserData () {
    this._userService.getUserData().subscribe(data => {
      this.fullName = `${data.lastname} ${data.firstname} ${data.middlename}`;;
      this.studentData = data;
      this.matric_no = data.matric_no;
    })
  }

  printSummary () {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment Summary`,
      }).subscribe(data => { });
    // console.log(this.invoicesArr);
    // console.log(this.student_details);

    let prn = window.open("", "PRINT", "height=700,width=1000");
    prn.document.write(
      "<html><head><title>" + document.title + " - Student Invoice  </title>"
    );
    prn.document.write("<body>");
    document.getElementById(
      "invoiceSummary"
    ).style.background = `url(${this.company_logo})`;
    prn.document.write(document.getElementById("invoiceSummary").innerHTML);
    prn.document.write("</body>");
    prn.document.write("</html>");
    prn.print();

  }


  printClearance () {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment Clearance`,
      }).subscribe(data => { });
    let prn = window.open("", "PRINT", "height=700,width=1000");
    prn.document.write(
      "<html><head><title>" + document.title + " - Student Invoice  </title>"
    );
    prn.document.write("<body>");
    document.getElementById(
      "invoiceClearance"
    ).style.background = `url(${this.company_logo})`;
    prn.document.write(document.getElementById("invoiceClearance").innerHTML);
    prn.document.write("</body>");
    prn.document.write("</html>");
    prn.print();


  }

  printClearance2 () {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment Clearance`,
      }).subscribe(data => { });

    let prn = window.open("", "PRINT", "height=700,width=1000");
    prn.document.write(
      `<html>
        <head>
          <title>${this.studentData.matric_no} Student Invoice - ${document.title} </title>
            <style>
              * {
                margin: 0;
                padding: 0;
              }

              .details-box-container {
                display: grid;
                grid-template-columns: repeat(2, minmax(0, 1fr));
                min-width: 45rem;
              }

              .details-box-container>div {
                padding: .85rem;
                display: flex;
                gap: .4rem;
                flex-direction: column;
              }

              .details-box-container>div>div {
                font-weight: 500;
              }

              .signatures-container {
                display: flex;
                flex-wrap: wrap;
                margin-top: 5rem;
                justify-content: space-between;
                column-gap: 2rem;
                row-gap: 5rem;
              }
            </style>`
    );
    prn.document.write("<body>");
    prn.document.write(document.getElementById("invoiceClearance2").innerHTML);
    prn.document.write("</body>");
    prn.document.write("</html>");
    prn.document.close();
    prn.focus();
    prn.onload = function () {
      prn.print();
    };


  }

  clearanceAsPDF () {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment Clearance as PDF`,
      }).subscribe(data => { });
    let displayData = "";

    // this.company_logo =  this.getBase64ImageFromURL("https://edu.sqi.ng/wp-content/uploads/2019/01/co.jpg");

    var imgToExport: any = document.getElementById('imgToExport');
    var canvas = document.createElement('canvas');
    canvas.width = imgToExport.width;
    canvas.height = imgToExport.height;
    canvas.getContext('2d').drawImage(imgToExport, 0, 0);
    let url = canvas.toDataURL('image/png')

    // displayData += canvas;
    displayData +=
      `
      <h4 align="center">${this.company_name}</h4>
      <p><small>${this.company_address}</small></p>
      `

    displayData += `
      <h3 style="display: flex; justify-content: center;">CLASS/EXAM ADMITTANCE SLIP</h3>
      <p>I hereby confirm that <span class="name" style="text-transform:uppercase;"> <b>${this.studentData.lastname}}</b>
        ${this.studentData.firstname} ${this.studentData.middlename}</span> of  ${this.studentData.category} - ${this.studentData.name} -
          ${this.studentData.tag}} has paid <strong> ${((this.totalAmountPaid / this.totalAmount) * 100).toFixed(2)}% </strong>  of ${this.studentData.gender === 'male' ? 'his' : 'her'} fee.</p>
          
          <p style="display: flex; justify-content: end;margin-top: 60px;">...........................................</p>
          <p style="display: flex; justify-content: end;">Name, Signature and Date </p>

        
      <br>
      <footer style="position: fixed;bottom:0;right: 0;">
        <p style="letter-spacing: 5px;"> <i>EDOZZIER</i></p>
      </footer>
    `

    // var html = htmlToPdfmake(displayData);
    // const documentDefinition = { content: html };
    // pdfMake.createPdf(documentDefinition).download(`invoice-${this.studentData.matric_no}`);
  }

  printInvoice (invoice_id) {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment Invoice`,
      }).subscribe(data => { });
    let invoice = this.paymentHistory.filter(p => p.invoice_id == invoice_id)[0];
    let mywindow = window.open('about:parent', 'PRINT', 'height=700,width=1000');
    // let logo = this.company_logo;
    let displayData = '';
    displayData += '<html><head><title>' + document.title + '</title>';
    // displayData += '<link rel="stylesheet" href="https://maxcdn.bootstrapcdn.com/bootstrap/4.0.0/css/bootstrap.min.css" integrity="sha384-Gn5384xqQ1aoWXA+058RXPxPg6fy4IWvTNh0E263XmFcJlSAwiGgFAW/dAiS6JXm" crossorigin="anonymous">';
    displayData +=
      `<style>
            img{
              width: 50px;
              height: 50px
            }
            body{
              font-size: 12px
            }
        </style>`
      ;
    displayData += "</head><body>";

    displayData +=
      `     
        <table style="width: 100%;">
        <tr>
            <td>
             <img src="${this.company_logo}" style="width:50px;height:50px" />
 
            </td>
            <td>
                 <strong style='text-transform: uppercase'>${this.company_name}</strong>
                 <div>
                     <i>${this.company_address}</i>
                 </div>
            </td>
        </tr>
      </table>
    `;

    displayData += `
      <form id="box1">
        <fieldset>
        <legend>Student Info</legend>
        <table width="100%" border="0" cellspacing="0" cellpadding="0" >
          <tr style="padding-top: 10px">
            <td rowspan="2"><img name="" src="${this.studentData.passport}" width="70" alt="Passport"  /></td>
            <td><b>Student Name</b></td>
            <td><span class="name" style="text-transform:uppercase;">${this.fullName}</span></td>
            <td><b>Student ID</b>.</td>
            <td>${this.studentData.matric_no}</td>
          </tr>

          <tr style="border-bottom-width: 1px; border-bottom-style: solid; border-bottom-color: lightgrey">
            <td><b>Gender</b></td>
            <td>${this.studentData.gender}</td>
            <td><b>Class</b></td>
            <td style='text-transform: uppercase'>${this.studentData.category} - ${this.studentData.name} - ${this.studentData.tag}</td>
          </tr>

          <tr align="center" valign="bottom" style="background: white; color: black; font-weight: bolder">
            <td colspan="6"><font size="3">STUDENT INVOICE</font></td>
          <td><em>Invoice No: ${invoice_id}</em></td>
          </tr>
        </table>
        </fieldset>
    </form>
    `

    displayData += `
        <div id="box3">
        <table width="100%" border="1" style="border-collapse: collapse !important">
            <tr>
                <th style="text-align: left;padding-left: 10px;">
                    FEE
                </th>
                <th>
                    INVOICED
                </th>
                <th> 
                    PAID
                </th>
                <th>
                    DATE
                </th>
            </tr> 
    `;



    let invoices = invoice.invoice_details;
    for (let i = 0; i < invoices.length - 1; i++) {
      displayData += "<tr>";
      displayData += `
        <td style="text-align: left;padding-left: 10px">${invoices[i].title}</td>
        <td style="text-align: center;">${invoices[i].amount}</td>
        <td style="text-align: center;">-</td>
        <td style="text-align: center;">-</td>
      `;
      displayData += "</tr>";

    }

    let payments = invoice.payment_details;
    for (let i = 0; i < payments.length - 1; i++) {
      displayData += "<tr>";
      displayData += `
        <td style="text-align: left;padding-left: 10px">${payments[i].ref_no}</td>
        <td style="text-align: center;">-</td>
        <td style="text-align: center;">${payments[i].amount}</td>
        <td style="text-align: center;">${payments[i].date}</td>
      `;

      displayData += "</tr>";

    }

    displayData += `
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
    `

    displayData += `
      <tr>
          <td style="text-align: left;padding-left: 10px"><strong>TOTAL</strong></td>
          <td style="text-align: center;">&#8358; ${invoice.total_amount}</td>
          <td style="text-align: center;">&#8358; ${invoice.total_paid}</td>
          <td style="text-align: center;">Balance: &#8358; ${invoice.amount_remaining}</td>
      </tr>
      `

      ;
    mywindow.document.write(displayData);
    // mywindow.document.close(); // necessary for IE >= 10
    mywindow.focus(); // necessary for IE >= 10*/
    mywindow.print();
    // mywindow.close();

    // const pdfTable = this.pdfTable.nativeElement;


  }

  printPDF (invoice_id) {
    this.log
      .addLog({
        action: "Print",
        component: "Payment History",
        details: `Printed Payment PDF`,
      }).subscribe(data => { });
    let invoice = this.paymentHistory.filter(p => p.invoice_id == invoice_id)[0];
    let displayData = "";

    // this.company_logo =  this.getBase64ImageFromURL("https://edu.sqi.ng/wp-content/uploads/2019/01/co.jpg");

    // var imgToExport: any = document.getElementById('imgToExport');
    // var canvas = document.createElement('canvas');
    // canvas.width = imgToExport.width;
    // canvas.height = imgToExport.height;
    // canvas.getContext('2d').drawImage(imgToExport, 0, 0);
    // let url = canvas.toDataURL('image/png')

    // displayData += canvas;
    displayData +=
      `
      <h4 align="center">${this.company_name}</h4>
      <p><small>${this.company_address}</small></p>
      `

    displayData += `
      <p> 
          <b>Student Name: </b> <span style="text-transform: uppercase">${this.fullName} </span>
          <br> <b>Student ID: </b> ${this.studentData.matric_no}
          <br> <b>Class: </b> ${this.studentData.category} - ${this.studentData.name} - ${this.studentData.tag}
          <br> <b>Invoice No: </b> ${invoice_id}
      </p>
    `

    displayData += `
        <table width="100%" border="1" style="border-collapse: collapse !important; width: 100vw">
            <tr>
                <th style="text-align: left;padding-left: 10px;">
                    FEE
                </th>
                <th>
                    INVOICED
                </th>
                <th> 
                    PAID
                </th>
                <th>
                    DATE
                </th>
            </tr> 
        
    `

    let invoices = invoice.invoice_details;
    for (let i = 0; i < invoices.length - 1; i++) {
      displayData += "<tr>";
      displayData += `
        <td style="text-align: left;padding-left: 10px">${invoices[i].title}</td>
        <td style="text-align: center;">${invoices[i].amount}</td>
        <td style="text-align: center;">-</td>
        <td style="text-align: center;">-</td>
      `;
      displayData += "</tr>";

    };

    let payments = invoice.payment_details;
    for (let i = 0; i < payments.length - 1; i++) {
      displayData += "<tr>";
      displayData += `
        <td style="text-align: left;padding-left: 10px">${payments[i].ref_no}</td>
        <td style="text-align: center;">-</td>
        <td style="text-align: center;">${payments[i].amount}</td>
        <td style="text-align: center;">${payments[i].date}</td>
      `;

      displayData += "</tr>";

    }

    displayData += `
    <tr>
      <td colspan="4">&nbsp;</td>
    </tr>
    `

    displayData += `
      <tr>
          <td style="text-align: left;padding-left: 10px"><strong>TOTAL</strong></td>
          <td style="text-align: center;">&#8358; ${invoice.total_amount}</td>
          <td style="text-align: center;">&#8358; ${invoice.total_paid}</td>
          <td style="text-align: center;">Balance: &#8358; ${invoice.amount_remaining}</td>
      </tr>
      `

      ;

    displayData += "</table>";

    // var html = htmlToPdfmake(displayData);
    // const documentDefinition = { content: html };
    // pdfMake.createPdf(documentDefinition).download(`invoice-${this.studentData.matric_no}`);
  }


  // getBase64ImageFromURL(url) {
  //   // return new Promise((resolve, reject) => {
  //     var img = new Image();
  //     img.setAttribute("crossOrigin", "anonymous");
  //     img.onload = () => {
  //       var canvas = document.createElement("canvas");
  //       canvas.width = img.width;
  //       canvas.height = img.height;
  //       var ctx = canvas.getContext("2d");
  //       ctx.drawImage(img, 0, 0);
  //       var dataURL = canvas.toDataURL("image/png");
  //       return dataURL
  //     };
  //     img.onerror = error => {
  //       return error;
  //     };
  //     img.src = url;
  //   // });
  // }


  clearanceOffices = [];
  getClearanceOffices () {
    this._paymentService.getPaymentClearanceOffices().subscribe(({ data, success }) => {
      if (!success) {
        return;
      }

      this.clearanceOffices = data;
    })
  }
}
